import { Language } from '../../types';
import Vue from 'vue';

// 👇 Language tags are formaly defined in [RFC 5646](https://tools.ietf.org/html/rfc5646),
// which rely on the [ISO 639](https://en.wikipedia.org/wiki/ISO_639) standard
// (quite often the [ISO 639-1 code list](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes))
// for [language codes](https://en.wikipedia.org/wiki/Language_code) to be used.

export const languages: readonly Language[] = Object.freeze(
  [
    ['aa', 'Afar'],
    ['ab', 'Abkhazian'],
    ['af', 'Afrikaans'],
    ['ak', 'Akan'],
    ['am', 'Amharic'],
    ['ar', 'Arabic'],
    ['an', 'Aragonese'],
    ['as', 'Assamese'],
    ['av', 'Avaric'],
    ['ae', 'Avestan'],
    ['ay', 'Aymara'],
    ['az', 'Azerbaijani'],
    ['ba', 'Bashkir'],
    ['bm', 'Bambara'],
    ['be', 'Belarusian'],
    ['bn', 'Bengali'],
    ['bi', 'Bislama'],
    ['bo', 'Tibetan'],
    ['bs', 'Bosnian'],
    ['br', 'Breton'],
    ['bg', 'Bulgarian'],
    ['ca', 'Catalan'],
    ['cs', 'Czech'],
    ['ch', 'Chamorro'],
    ['ce', 'Chechen'],
    ['cu', 'Church Slavic'],
    ['cv', 'Chuvash'],
    ['kw', 'Cornish'],
    ['co', 'Corsican'],
    ['cr', 'Cree'],
    ['cy', 'Welsh'],
    ['da', 'Danish'],
    ['de', 'German'],
    ['dv', 'Dhivehi'],
    ['dz', 'Dzongkha'],
    ['el', 'Modern Greek (1453-)'],
    ['en', 'English'],
    ['eo', 'Esperanto'],
    ['et', 'Estonian'],
    ['eu', 'Basque'],
    ['ee', 'Ewe'],
    ['fo', 'Faroese'],
    ['fa', 'Persian'],
    ['fj', 'Fijian'],
    ['fi', 'Finnish'],
    ['fr', 'French'],
    ['fy', 'Western Frisian'],
    ['ff', 'Fulah'],
    ['gd', 'Scottish Gaelic'],
    ['ga', 'Irish'],
    ['gl', 'Galician'],
    ['gv', 'Manx'],
    ['gn', 'Guarani'],
    ['gu', 'Gujarati'],
    ['ht', 'Haitian'],
    ['ha', 'Hausa'],
    ['sh', 'Serbo-Croatian'],
    ['he', 'Hebrew'],
    ['hz', 'Herero'],
    ['hi', 'Hindi'],
    ['ho', 'Hiri Motu'],
    ['hr', 'Croatian'],
    ['hu', 'Hungarian'],
    ['hy', 'Armenian'],
    ['ig', 'Igbo'],
    ['io', 'Ido'],
    ['ii', 'Sichuan Yi'],
    ['iu', 'Inuktitut'],
    ['ie', 'Interlingue'],
    ['ia', 'Interlingua (International Auxiliary Language Association)'],
    ['id', 'Indonesian'],
    ['ik', 'Inupiaq'],
    ['is', 'Icelandic'],
    ['it', 'Italian'],
    ['jv', 'Javanese'],
    ['ja', 'Japanese', '日本語'],
    ['kl', 'Kalaallisut'],
    ['kn', 'Kannada'],
    ['ks', 'Kashmiri'],
    ['ka', 'Georgian'],
    ['kr', 'Kanuri'],
    ['kk', 'Kazakh'],
    ['km', 'Central Khmer'],
    ['ki', 'Kikuyu'],
    ['rw', 'Kinyarwanda'],
    ['ky', 'Kirghiz'],
    ['kv', 'Komi'],
    ['kg', 'Kongo'],
    ['ko', 'Korean'],
    ['kj', 'Kuanyama'],
    ['ku', 'Kurdish'],
    ['lo', 'Lao'],
    ['la', 'Latin'],
    ['lv', 'Latvian'],
    ['li', 'Limburgan'],
    ['ln', 'Lingala'],
    ['lt', 'Lithuanian'],
    ['lb', 'Luxembourgish'],
    ['lu', 'Luba-Katanga'],
    ['lg', 'Ganda'],
    ['mh', 'Marshallese'],
    ['ml', 'Malayalam'],
    ['mr', 'Marathi'],
    ['mk', 'Macedonian'],
    ['mg', 'Malagasy'],
    ['mt', 'Maltese'],
    ['mn', 'Mongolian'],
    ['mi', 'Maori'],
    ['ms', 'Malay (macrolanguage)', 'Bahasa Melayu'],
    ['my', 'Burmese'],
    ['na', 'Nauru'],
    ['nv', 'Navajo'],
    ['nr', 'South Ndebele'],
    ['nd', 'North Ndebele'],
    ['ng', 'Ndonga'],
    ['ne', 'Nepali (macrolanguage)'],
    ['nl', 'Dutch'],
    ['nn', 'Norwegian Nynorsk'],
    ['nb', 'Norwegian Bokmål'],
    ['no', 'Norwegian'],
    ['ny', 'Nyanja'],
    ['oc', 'Occitan (post 1500)'],
    ['oj', 'Ojibwa'],
    ['or', 'Oriya (macrolanguage)'],
    ['om', 'Oromo'],
    ['os', 'Ossetian'],
    ['pa', 'Panjabi'],
    ['pi', 'Pali'],
    ['pl', 'Polish'],
    ['pt', 'Portuguese'],
    ['ps', 'Pushto'],
    ['qu', 'Quechua'],
    ['rm', 'Romansh'],
    ['ro', 'Romanian'],
    ['rn', 'Rundi'],
    ['ru', 'Russian'],
    ['sg', 'Sango'],
    ['sa', 'Sanskrit'],
    ['si', 'Sinhala'],
    ['sk', 'Slovak'],
    ['sl', 'Slovenian'],
    ['se', 'Northern Sami'],
    ['sm', 'Samoan'],
    ['sn', 'Shona'],
    ['sd', 'Sindhi'],
    ['so', 'Somali'],
    ['st', 'Southern Sotho'],
    ['es', 'Spanish'],
    ['sq', 'Albanian'],
    ['sc', 'Sardinian'],
    ['sr', 'Serbian'],
    ['ss', 'Swati'],
    ['su', 'Sundanese'],
    ['sw', 'Swahili (macrolanguage)'],
    ['sv', 'Swedish'],
    ['ty', 'Tahitian'],
    ['ta', 'Tamil'],
    ['tt', 'Tatar'],
    ['te', 'Telugu'],
    ['tg', 'Tajik'],
    ['tl', 'Tagalog'],
    ['th', 'Thai'],
    ['ti', 'Tigrinya'],
    ['to', 'Tonga (Tonga Islands)'],
    ['tn', 'Tswana'],
    ['ts', 'Tsonga'],
    ['tk', 'Turkmen'],
    ['tr', 'Turkish'],
    ['tw', 'Twi'],
    ['ug', 'Uighur'],
    ['uk', 'Ukrainian'],
    ['ur', 'Urdu'],
    ['uz', 'Uzbek'],
    ['ve', 'Venda'],
    ['vi', 'Vietnamese'],
    ['vo', 'Volapük'],
    ['wa', 'Walloon'],
    ['wo', 'Wolof'],
    ['xh', 'Xhosa'],
    ['yi', 'Yiddish'],
    ['yo', 'Yoruba'],
    ['za', 'Zhuang'],
    ['zh-CN', 'Chinese', '中文'],
    ['zh-TW', 'Chinese (Traditional)', '中文（繁體）'],
    ['zu', 'Zulu'],
  ].map<Language>(([code, enLabel, label]) =>
    Object.freeze({ code, enLabel, label: label || enLabel }),
  ),
);

export function getLanguages(): Language[] {
  return languages.slice();
}

const getLangForCode = (
  languages: Language[],
  code: string | null | undefined,
): Language | undefined => {
  if (!code) {
    return undefined;
  }
  const pair = code.split('-');
  const isPair = pair.length === 2;
  const short = isPair ? pair[0] : undefined;
  return languages.find(l => l.code === code || (isPair && l.code === short));
};

export const languageForCode = (code: string | null | undefined) => {
  return getLangForCode(languages as Language[], code);
};

export const languagesForCodes = (
  codes: (string | null | undefined)[],
  options: { keepUnset?: boolean } = {},
) => {
  const result = codes.map(code =>
    getLangForCode(languages as Language[], code),
  );
  if (options.keepUnset) {
    return result;
  }
  return result.filter(l => l) as Language[];
};

export const isValidLanguageCode = (code: string): boolean =>
  languageForCode(code) !== undefined;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const english: Language = languageForCode('en')!;

interface LangauagesStore {
  languages: Language[];
  selected: Language | null;
  default: Language;
}

export class LangService {
  constructor() {
    this.store = Vue.observable({
      languages: getLanguages(),
      selected: null,
      default: english,
    });
  }

  private store: LangauagesStore;

  get languages() {
    return this.store.languages;
  }

  setLanguages(codes?: string[] | Language[]) {
    if (!codes || codes.length === 0) {
      this.store.languages = getLanguages();
    } else if (typeof codes[0] === 'string') {
      this.store.languages = languagesForCodes(codes as string[]) as Language[];
    } else {
      this.store.languages = codes as Language[];
    }
  }

  get selected() {
    return this.store.selected || this.store.default;
  }

  set selected(lang: Language | null) {
    this.store.selected = lang;
  }

  get selectedCode() {
    return this.selected?.code || this.store.default.code;
  }

  set selectedCode(code: string | null) {
    if (!code) {
      this.selected = null;
    } else {
      const language = this.langForCode(code);
      if (!language) {
        throw new Error('Invalid code');
      }
      this.selected = language;
    }
  }

  get default() {
    return this.store.default;
  }

  set default(lang: Language) {
    this.store.default = lang;
  }

  get defaultCode() {
    return this.default.code;
  }

  set defaultCode(code: string) {
    const language = this.langForCode(code);
    if (!language) {
      throw new Error('Invalid code');
    }
    this.default = language;
  }

  langForCode(code: string | null | undefined) {
    return getLangForCode(this.store.languages, code);
  }

  langsForCodes(
    codes: (string | null | undefined)[],
    options: { keepUnset?: boolean } = {},
  ) {
    const { languages } = this.store;
    const result = codes.map(code => getLangForCode(languages, code));
    if (options.keepUnset) {
      return result;
    }
    return result.filter(l => l);
  }
}

const langService = new LangService();

export default langService;
